import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'getKeys'
})
export class GetKeysPipe implements PipeTransform {
    transform(value: { [key: string]: any }): string[] {
        if (typeof value !== 'object') {
            return [];
        }

        return Object.keys(value).filter((key: string) => key !== 'undefined');
    }
}
